// inventorySectionHealthLogic.js
import _ from "lodash"
import moment from "moment"
import numeral from "numeral"
import helpers from "helpers/helpers"

export const calculateSectionHealth = (props, substantiallyOnly = false) => {
	let store = []
	let model = {
		vdl_builder: 0,
		vdl_dev: 0,
		remaining_months_12: 0,
		remaining_months_4: 0,
		avg_monthly_sales_12: 0,
		avg_monthly_sales_4: 0,
		momentum: 0,
		unsold: false, // Add this new property
	}

	// Build base
	_.forEach(props.payload.public.sections, (v) => {
		if (substantiallyOnly && !v.substantially_complete) return
		if (props.activeProperties.includes(v.property)) {
			let com = _.find(props.payload.public.properties, { id: v.property })
			if (!com) throw `Cannot find required info for lotid ${v.id}`
			let est_days
			if (v?.estimated_delivery && v.estimated_delivery > moment().unix()) {
				est_days = moment.unix(v.estimated_delivery).diff(moment(), "days")
			}
			store.push({
				community: com.name,
				section: v.name,
				section_id: v.id,
				est_days,
				..._.clone(model),
			})
		}
	})

	_.forEach(props.payload.exec.lots, (v) => {
		try {
			if (substantiallyOnly && !v.substantially_complete) return
			let com = _.find(props.payload.public.properties, { id: v.property })
			let section = _.find(props.payload.public.sections, { id: v.section_id })
			if (!com || !section) throw `Cannot find required info for lotid ${v.id}`
			let look = { community: com.name, section: section.name }
			let index = _.findIndex(store, look)
			if (index === -1) {
				throw `Can't find index.`
			}

			if (!v.takedown_date) {
				store[index].vdl_dev++
			} else if (helpers.isBuilderVDL(v)) {
				store[index].vdl_builder++
			}
		} catch (e) {
			console.error(e)
		}
	})

	// 12 months calculations
	let oneYear = moment().subtract(1, "year").unix()
	_.forEach(store, (v) => {
		let earliestSale
		let sales = _.filter(props.payload.exec.sales, (r) => {
			if (r.section_id == v.section_id && r.sale_date >= oneYear) {
				if (!earliestSale || r.sale_date < earliestSale) earliestSale = r.sale_date
				return true
			}
		})
		let numMonths = 0
		if (earliestSale) {
			numMonths = moment.unix(moment().unix()).diff(moment.unix(earliestSale), "months")
		}
		v.avg_monthly_sales_12 = 0
		if (numMonths) {
			v.avg_monthly_sales_12 = parseFloat(numeral(sales.length / numMonths).format("0,0.00"))
		}

		// Add check for unsold sections
		if ((v.vdl_builder > 0 || v.vdl_dev > 0) && v.avg_monthly_sales_12 === 0) {
			v.unsold = true
			v.remaining_months_12 = null
		} else {
			v.unsold = false
			let ops = (v.vdl_builder + v.vdl_dev) / v.avg_monthly_sales_12
			if (!isNaN(ops) && isFinite(ops)) {
				v.remaining_months_12 = parseFloat(numeral(ops).format("0,0.00"))
			} else v.remaining_months_12 = null
		}
	})

	// 4 months calculations
	let fourthMonths = moment().subtract(4, "months").unix()
	_.forEach(store, (v) => {
		let earliestSale
		let sales = _.filter(props.payload.exec.sales, (r) => {
			if (r.section_id == v.section_id && r.sale_date >= fourthMonths) {
				if (!earliestSale || r.sale_date < earliestSale) earliestSale = r.sale_date
				return true
			}
		})
		let numMonths = 0
		if (earliestSale) {
			numMonths = moment.unix(moment().unix()).diff(moment.unix(earliestSale), "months")
		}
		v.avg_monthly_sales_4 = 0
		if (numMonths) {
			v.avg_monthly_sales_4 = parseFloat(numeral(sales.length / numMonths).format("0,0.00"))
		}
		let ops = (v.vdl_builder + v.vdl_dev) / v.avg_monthly_sales_4
		if (!isNaN(ops) && isFinite(ops)) {
			v.remaining_months_4 = parseFloat(numeral(ops).format("0,0.00"))
		} else v.remaining_months_4 = null
	})

	_.forEach(store, (v) => {
		let calc = helpers.percentChange(v.avg_monthly_sales_12, v.avg_monthly_sales_4)
		v.momentum = calc || null
	})

	return store
}

export default calculateSectionHealth
